import React from 'react';
import PropTypes from 'prop-types';

import RenderBlocks from '~/components/editor/RenderBlocks';

export default class Tabs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      block: props.block,
      current: 0,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.block !== prevProps.block) {
      this.setState({ block: this.props.block });
    }
    this.calcSpanPosition(this.state.current);
  }

  componentDidMount() {
    this.calcSpanPosition(this.state.current);
  }

  changeCurrent(index) {
    this.setState({ current: index })
  }

  calcSpanPosition(index) {
    const tabAfterParams = {
      position: 0,
      width: $(`.tab:eq(${index})`).innerWidth(),
    };

    for (let i = 0; i < index; i++) {
      tabAfterParams.position += $(`.tab:eq(${i})`).outerWidth(true);
    }

    if (window.innerWidth < 768) {
      tabAfterParams.position += 15;
    }

    $('.tabs__head span').css('left', `${tabAfterParams.position}px`);
    $('.tabs__head span').css('width', `${tabAfterParams.width}px`);
  }

  prepareTabs() {
    const { block, current } = this.state;

    const tabs = block.content.group_tabs.map((b, index) => {
      const classes = ['tab'];
      if (current === index) classes.push('is-active');

      return (
        <button
          key={`tab_${index}`}
          onClick={e => this.setState({ current: index })}
          className={classes.join(' ')}
        >
          {b.title}
        </button>
      );
    });

    return tabs;
  }

  prepareTabContent() {
    const { onChildAction, onAddChild } = this.props;
    const { block, current } = this.state;
    const tabs = block.content.group_tabs.map((b, index) => {
      const classes = ['tabs__content'];
      if (current === index) classes.push('is-active');
      return (
        <div key={`tab-content_${index}`} className={classes.join(' ')}>
          {b.children && (
            <RenderBlocks
              data={b.children}
              children={true}
              onBlockAction={(type, sort, action) =>
                onChildAction(type, sort, action, index)
              }
            />
          )}
          <button
            className="editor__btn-addblock editor__btn-addblock--red for-admin"
            onClick={() => onAddChild(index)}
          >
            Добавить блок
          </button>
        </div>
      );
    });

    return tabs;
  }

  render() {

    return (
      <div className="tabs">
        <div className="tabs__head">
          <nav className="tabs__wrap">{this.prepareTabs()}<span></span></nav>
        </div>
        <div className="tabs__body">{this.prepareTabContent()}</div>
      </div>
    );
  }
}
